import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useURL custom hook. Returns project urls.
 */
export default function useURLs() {
	const {managerRepository} = useGeneralProvider();

	return {
		CART: managerRepository.getSfccAPI().generateEndpointUrl('Cart-Show', true),
		PAYPAL_POPUP: managerRepository.getSfccAPI().generateEndpointUrl('Paypal-Popup', true)
	};
}
